/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;height:100%;flex-direction:column}.filter-panel[_ngcontent-%COMP%]{display:flex;justify-items:start;align-items:center;padding:10px;background-color:#f5f5f5}.filter-panel[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-right:10px}dx-data-grid[_ngcontent-%COMP%]{flex:auto}"];
export { styles as styles };
